import { useState, useEffect } from 'react';

export default function UpdateMultiCheckBox({
  title,
  hint,
  data,
  previousData,
  setSelectedData,
  dotName,
  labelColor,
  borderColor,
}) {
  const [selected, setSelected] = useState([]);

  const handleChange = (event) => {
    const { checked, value } = event.currentTarget;

    /* setSelected((prev) =>
      checked ? [...prev, value] : prev.filter((val) => val !== value),
    ); */

    setSelected(() =>
      checked ? [...selected, value] : selected.filter((val) => val !== value),
    );
  };

  useEffect(() => {
    let tempData = previousData?.map((a) => a.id.toString());
    setSelected(tempData);
  }, [previousData]);

  useEffect(() => {
    setSelectedData(selected);
  }, [selected]);

  const difference = data?.filter(
    (item) =>
      !previousData?.some((itemToBeRemoved) => itemToBeRemoved.id === item.id),
  );

  return (
    <fieldset className='space-y-5'>
      <div>
        <legend className='sr-only'>{title}</legend>
        <label className={`${labelColor} text-base font-medium text-brandText`}>
          {title}
        </label>
        <p className={`${labelColor} text-sm leading-5 text-brandText`}>
          Please select all that apply.
        </p>
      </div>
      {previousData?.map((item) => (
        <div key={item.id} className='relative flex items-start'>
          <div className='flex h-5 items-center'>
            <input
              id={item[dotName]}
              value={item.id}
              defaultChecked={true}
              type='checkbox'
              onChange={handleChange}
              className='h-4 w-4 rounded border-gray-300 text-brandPrimary focus:ring-brandPrimary'
            />
          </div>
          <div className='ml-3 text-sm'>
            <label
              htmlFor={item[dotName]}
              className='font-medium text-brandText'
            >
              {item[dotName]}
            </label>
            <span id='comments-description' className='text-brandText'>
              {hint}
            </span>
          </div>
        </div>
      ))}
      {difference?.map((item, itemIdx) => (
        <div key={itemIdx} className='relative flex items-start'>
          <div className='flex h-5 items-center'>
            <input
              id={`item[dotName]${itemIdx}`}
              value={item.id}
              type='checkbox'
              onChange={handleChange}
              className='h-4 w-4 rounded border-gray-300 text-brandPrimary focus:ring-brandPrimary'
            />
          </div>
          <div className='ml-3 text-sm'>
            <label
              htmlFor={`item[dotName]${itemIdx}`}
              className='font-medium text-brandText'
            >
              {item[dotName]}
            </label>
            <span id='comments-description' className='text-brandText'>
              {hint}
            </span>
          </div>
        </div>
      ))}
    </fieldset>
  );
}
